import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { UrlService } from '@service/url/url.service';
import { CarrierService } from '@service/carrier/carrier.service';
import { UtilService } from '@service/util/util.service';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { IS_NOT_EMPTY, IS_NOT_NULL_OR_UNDEFINED, IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

@Component({
	selector: 'app-account-autocomplete',
	templateUrl: './account-autocomplete.component.html',
	styleUrls: ['./account-autocomplete.component.scss'],
})
export class AccountAutocompleteComponent implements OnInit {
	isLoading = false;

	accountCtrl = new UntypedFormControl();
	listOfAccounts: any[];

	@ViewChild('accountInput') accountInput: ElementRef;
	@ViewChild('auto') matAutocomplete: MatAutocomplete;
	@Input() selectedCarrier: any = null;
	@Output() accountSelected: EventEmitter<any> = new EventEmitter();

	constructor(
		private urlService: UrlService,
		private carrierService: CarrierService,
		public utilService: UtilService
	) {}

	ngOnInit() {
		if (IS_NOT_NULL_OR_UNDEFINED(this.selectedCarrier)) {
			this.accountCtrl.setValue(this.selectedCarrier);
		}
	}

	ngOnChanges() {
		if (IS_NULL_OR_UNDEFINED(this.selectedCarrier)) {
			this.accountCtrl.setValue('');
		} else {
			this.accountCtrl.setValue(this.selectedCarrier);
		}
	}

	selected(event: MatAutocompleteSelectedEvent): void {
		this.accountSelected.emit(event.option.value);
	}

	displayFn(carrier: any) {
		return carrier && carrier.businessName ? carrier.businessName : '';
	}

	keyPressed(event: any){
		this.accountCtrl.valueChanges
			.pipe(
				debounceTime(300),
				tap(() => {
					this.isLoading = true;
				}),
				switchMap((value) => {
					if (IS_NOT_EMPTY(value) && IS_NOT_NULL_OR_UNDEFINED(value)) {
						return this.carrierService.search(this.urlService.searchAccountsUrl(value));
					} else if (
						IS_NOT_NULL_OR_UNDEFINED(this.accountInput.nativeElement.value) &&
						IS_NOT_EMPTY(this.accountInput.nativeElement.value)
					) {
						return;
					}
					this.accountSelected.emit(null);
					this.isLoading = false;
				})
			)
			.subscribe(
				(accounts) => {
					this.listOfAccounts = accounts.accounts;
					this.isLoading = false;
				},
				(error) => {
					this.isLoading = false;
				}
			);
	}
}
